<!-- TODO:(Keerthika) commented aura related classes as its part of omni channel, cleanup required -->
<div class="flex flex-col items-center" data-cy="journey-container">
  <!-- <div
  class="flex flex-col items-center"
  [ngClass]="
    content.aspect ? 'aura-tracker-journey__container__' + content.aspect : ''
  "
> -->
  <div class="flex flex-col text-[#161B38]" data-cy="journey-content">
    <div
      *ngIf="content.pending"
      class="flex gap-4 items-center justify-center"
      data-cy="pending-container"
    >
      <div
        class="text-body-xs text-center"
        data-cy="pending-text"
      >
        {{ content.pending }}
      </div>
      <button id="tooltip-trigger-basic" data-cy="tooltip-trigger">
        <img
          src=" /content/dam/delta-applications/ui-kit/assets/svg/skymiles/tracker/skymiles-member/infotooltip-mach.svg"
          data-cy="tooltip-icon"
        />
      </button>
      <!-- TODO: (Keerthika) tooltip works fine for laptop, mobile, for desktop issue is raised to machcore team. -->
      <div id="basic-tooltip" class="tooltip relative" data-cy="tooltip">
        <button
          class="tooltip-close-btn cursor-pointer absolute right-2"
          data-cy="tooltip-close-btn"
        >
          <span class="tooltip-close-icon" data-cy="tooltip-close-icon"></span>
        </button>
        <div class="flex items-center gap-8 pr-8" data-cy="tooltip-content">
          <div class="information-icon size-5" data-cy="information-icon"></div>
          <div
            class="text-label-xs-medium pending-tooltip-content"
            [innerHTML]="content.info"
            data-cy="tooltip-info"
          ></div>
        </div>
      </div>
    </div>
    <div
      *ngIf="
        content.qualifier.length === 1 ||
        (content.aspect === 'collapse' && content.qualifier.length >= 1)
      "
      class="text-center mt-8 text-label-xs-semibold"
      data-cy="qualifier-text"
    >
      <!-- <div
      *ngIf="
        content.qualifier.length === 1 ||
        (content.aspect === 'collapse' && content.qualifier.length >= 1)
      "
      [ngClass]="
        content.aspect
          ? 'aura-tracker-journey__qualifier__' + content.aspect
          : ''
      "
      class="text-center mt-8 text-label-xs-semibold text-heading"
    > -->
      {{ content.qualifier[0] }}
    </div>
    <div
      *ngIf="content.reached"
      class="text-center mt-8 text-label-xs-semibold text-heading"
      data-cy="reached-text"
    >
      <!-- <div
      *ngIf="content.reached"
      [ngClass]="
        content.aspect ? 'aura-tracker-journey__reached__' + content.aspect : ''
      "
      class="text-center mt-8 text-label-xs-semibold text-heading"
    > -->
      {{ content.reached }}
    </div>
    <!--  TODO: (Keerthika ): Commented out as its part of omnichannel  -->
    <!-- <div
      *ngIf="content.more && content.qualifier.length > 1 && !content.aspect"
      class="aura-tracker-journey__more-tiers"
    >
      <div class="aura-tracker-journey__more-tiers__qualifier">
        {{ content.qualifier[0] }}
      </div>
      <div class="aura-tracker-journey__more-tiers__label">
        <div class="aura-tracker-journey__more-tiers__label__more">
          {{ content.more }}
        </div>
        <div *ngIf="content.info">
          <button
            auraTooltip
            [tooltipContent]="qualifierTooltip"
            [template]="auraToolTip"
            class="aura-tracker-journey__more-tiers__label__icon"
          >
            <img alt="info icon" />
          </button>
          <ng-template #auraToolTip>
            <div class="aura-tracker-journey__more-tiers__tooltip">
              <div
                *ngFor="
                  let qualifier of content.qualifier | slice : 1;
                  let i = index
                "
              >
                <div class="aura-tracker-journey__more-tiers__tooltip__label">
                  {{ qualifier }}
                </div>
                <div
                  *ngIf="i !== content.qualifier.length - 2"
                  class="aura-tracker-journey__more-tiers__tooltip__divider"
                >
                  <aura-divider></aura-divider>
                </div>
              </div>
            </div>
          </ng-template>
        </div>
      </div>
    </div> -->
  </div>
  <!-- TODO: (Keerthika) Commented out as its part of omnichannel -->
  <!-- <div
    class="aura-tracker-journey__toggle"
    *ngIf="!content.more && content.qualifier.length > 1"
  >
    <aura-toggle-area
      [entryItem]="entryItem"
      [boxShadow]="false"
      [borderType]="'solid'"
      [separator]="false"
    >
      <div class="aura-tracker-journey__toggle__wrapper">
        <div *ngFor="let qualifier of content.qualifier | slice : 1">
          {{ qualifier }}
        </div>
      </div>
    </aura-toggle-area>
  </div> -->
</div>
